import { render } from "./LoginComponent.vue?vue&type=template&id=d6b7aa16&ts=true"
import script from "./LoginComponent.vue?vue&type=script&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__